// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-select{margin:10px 0}.cropper-crop-box,.cropper-view-box{border-radius:500px}.img-cropper>div>img{border-radius:250px}.vs__dropdown-toggle{background:#e7e7e7;border:none;border-radius:25px;padding-right:5px}.vs__selected-options{padding:5px 15px}.vs__selected-options:focus{padding:10px 15px}.vs__dropdown-option--highlight{background:#000;color:#fff}.vs__dropdown-menu{background:#e7e7e7;border:none;box-shadow:0 5px 5px -3px rgba(0,0,0,.25)}.vs__actions{display:none}", ""]);
// Exports
module.exports = exports;
